var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#FB776C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 45.0001,
    cy: 44.9998,
    r: 36.8182,
    fill: "#FB776C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 44.9996,
    cy: 44.9996,
    r: 28.6364,
    fill: "#FB776C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9995 50.961C43.8949 50.961 43.0358 50.0916 43.0358 48.9739V33.1399C43.0358 32.0222 43.8949 31.0908 44.9995 31.0908C46.0426 31.0908 46.9631 32.0222 46.9631 33.1399V49.036C46.9631 50.0916 46.0426 50.961 44.9995 50.961ZM44.9995 53.9415C46.3495 53.9415 47.454 55.1213 47.454 56.4252C47.454 57.7913 46.3495 58.909 44.9995 58.909C43.5881 58.909 42.5449 57.8534 42.5449 56.4252C42.5449 55.0592 43.5881 53.9415 44.9995 53.9415Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.6581501afb1121a89deec9c82f255c30.svg";
export { ForwardRef as ReactComponent };